import type { WebSocketResponseMessage } from '../../proto/generated/websocket'

/**
 * The initial-data frame is the one carrying the bootstrap payloads; subscription frames
 * (snapshots, candles, order books) never do. The server can deliver a snapshot for the
 * global subscription before the initial data, so the frame is identified by content, not
 * by being first. The HTTP endpoints for the same data are only a fallback, used when this
 * frame does not arrive (see App.requestInitialDataBackup).
 */
export const isInitialDataFrame = (message: WebSocketResponseMessage): boolean =>
    Boolean(
        message.superChartConfig ||
            message.userDashboards ||
            message.tradingCalendars ||
            message.brokers ||
            message.tradingAccounts ||
            message.userSecurityExpressions
    )

/** How long to wait for the initial-data frame after the socket starts talking before falling back to HTTP. */
export const INITIAL_DATA_FALLBACK_MS = 5000
